var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMomentumReversalsBottoming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.096 28.008a1.25 1.25 0 001.715-.05L34.499 15.27v8.237a1.25 1.25 0 002.501 0V12.25C37 11.56 36.44 11 35.75 11H24.492a1.25 1.25 0 100 2.501h8.237L20.876 25.355 5.082 11.315a1.25 1.25 0 00-1.662 1.87l16.676 14.823z"
  })));
}
export default SvgMomentumReversalsBottoming;